export default __webpack_public_path__ + "static/bsdex_animation-ba6a9e55db903a71720f81843da56fcb.mp4";